<section class="main">
  <h2>Add village Config</h2>
  <hr />
  <form [formGroup]="Village_form">
    <mat-form-field>
      <mat-label>Choose Village</mat-label>
      <mat-select multiple formControlName="villages">
        <mat-option *ngFor="let item of village_list" [value]="item.id">
          {{ item.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div>
      <mat-slide-toggle formControlName="kids_access"  [color]="color">
        Kids access
      </mat-slide-toggle>
    </div>

    <div class="mt-3">
      <mat-slide-toggle formControlName="rented_unit" [color]="color">
        Rented unit
      </mat-slide-toggle>
    </div>
  </form>

  <div class="footer mt-4">
    <button class="btn addGate" (click)="add_village_config()">Add Config</button>
    <button class="btn" mat-dialog-close>Cancel</button>
  </div>
</section>
